import React from 'react'

const AccreditationAgencySelector = (props) => {
  const {
    agencyId,
    setAgencyId,
    agencies
  } = props

  tangibleFields.event('valueChange', field => {
    if ( field.name === 'agency_id' ){
      setAgencyId(field.value)
    }
  })

  const agenciesSelect = tangibleFields.render({
    type: 'select',
    name: 'agency_id',
    value: agencyId,
    label: 'Accrediting Agency',
    description: 'Select the Accrediting Agency you would like to associate this accreditation with. This is the organization your students will have their continuing education credits certified by.',
    choices: JSON.parse(agencies),
  })

  return (
    <>
      <div className="tgbl-agency-select-block tgbl-field-block">
        {agenciesSelect}
      </div>
    </>
  )
}

export default AccreditationAgencySelector
